import { payableBands } from "../../../shared/account-finance/payables-domain";
import type { PayableRow, FinanceDirection } from "../../../shared/account-finance/payables-domain";

export function payablesProgress(rows: PayableRow[], date: string, direction: FinanceDirection) {
  const result = { read: 0, waiting: 0, failed: 0, unverified: 0, uncertainDue: 0, nonInvoice: 0 };
  for (const row of rows) {
    if (row.readError) { result.failed++; continue; }
    if (!row.account || !row.observedAt) { result.waiting++; continue; }
    result.read++;
    const balance = BigInt(row.account.balance) * (direction === "payables" ? -1n : 1n);
    // Advances do not belong to this direction's invoice aging.
    if (balance < 0n) continue;
    const bands = payableBands(row, date, direction);
    if (!bands) result.unverified++;
    else {
      const other = BigInt(row.aging?.otherRemaining ?? "0");
      if (other > 1n) result.nonInvoice++;
      if (BigInt(bands.unknown) - other > 1n) result.uncertainDue++;
    }
  }
  return result;
}
